import { Component, Vue, Inject } from "vue-property-decorator";
import Vue2Filters from "vue2-filters";
import AlertMixin from "@/shared/alert/alert.mixin";
import { mixins } from "vue-class-component";
import DataConvertUtils from "@/commons/DataConvertUtils";
import LoginApi from "@/data/api/LoginApi";
@Component({
  mixins: [Vue2Filters.mixin],
})
export default class Login extends mixins(AlertMixin) {
  private dataConvertor: DataConvertUtils = DataConvertUtils.instance;
  @Inject("loginApi") private loginApi: () => LoginApi;
  private errorMessenger: boolean = true;
  private data: any = [];
  private id: any = null;
  private formLogin: any = {
    username: null,
    password: null,
  };
  constructor() {
    super();
  }
  public created() {
    this.data = this.menuDefault;

    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.checUrlUser(user);
    }
  }
  public checUrlUser(user) {
    let x = [];
    this.data.forEach((item, index) => {
      if (item.childrens.length > 0) {
        item.childrens.forEach((e, i) => {
          user.roles_detail.forEach((b) => {
            b.features.filter((c) => {
              if (c.id === e.id) {
                x.push(e);
              }
            });
          });
        });
      } else {
        user.roles_detail.forEach((d) => {
          d.features.filter((f) => {
            if (item.id === f.id) {
              x.push(item);
            }
          });
        });
      }
    });
    this.$router.push(x[0].path);
  }
  public resertInput(string: string) {
    this.formLogin[string] = null;
  }
  public submitForm() {
    if (this.formLogin.username == null || this.formLogin.username == "") {
      this.popupError("Tên đăng nhập và mật khẩu là trường bắt buộc");
      return;
    }
    if (this.formLogin.password == null || this.formLogin.password == "") {
      this.popupError("Tên đăng nhập và mật khẩu là trường bắt buộc");
      return;
    }
    let query: any = {
      username: this.formLogin.username.trim(),
      password: this.formLogin.password.trim(),
    };
    this.loginApi()
      .Login(query)
      .then(
        (res) => {
          if (res) {
            this.errorMessenger = false;
            let obj = res;
            obj.expiDate = new Date().setMinutes(new Date().getMinutes() + 30);
            localStorage.setItem("user", JSON.stringify(obj));
            this.$store.commit("setloginSuccess", obj);
            if (res.roles_detail) {
              this.checUrlUser(obj);
            } else this.$router.push("/not-found");
          }
        },
        (err) => {
          this.popupError("Sai tài khoản hoặc mật khẩu");
        }
      );
  }
  public popupError(message: string) {
    window.toastr.error(
      `<div class='d-flex justify-content-between'><div class='d-flex align-items-center pr-2'>${message}</div><div class='pt-1'><button type="button" class="close-toastr el-button el-button--danger el-button--small btn-toast">Đóng</button></div></div>`
    );
    window.$(".close-toastr").on("click", function () {
      // @ts-ignore
      window.toastr.clear(window.$(this).closest(".toast"), { force: true });
    });
  }
}
